import { render, staticRenderFns } from "./LandingPageBrendanVacations.vue?vue&type=template&id=19248ed9&scoped=true&"
import script from "./LandingPageBrendanVacations.vue?vue&type=script&lang=js&"
export * from "./LandingPageBrendanVacations.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageBrendanVacations.vue?vue&type=style&index=0&id=19248ed9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19248ed9",
  null
  
)

export default component.exports